// Silifke Sepeti: mobil çekmece (drawer) aç/kapa ve header arama ikonu davranışı
document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('mobileDrawer');
  var overlay = document.getElementById('drawerOverlay');
  var toggleButtons = document.querySelectorAll('[data-drawer-toggle]');
  var closeButtons = document.querySelectorAll('[data-drawer-close]');
  var searchFocusButtons = document.querySelectorAll('[data-drawer-search-focus]');

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var toggle = document.querySelector('[data-drawer-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    var toggle = document.querySelector('[data-drawer-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  toggleButtons.forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });
  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  // header'daki büyüteç ikonu: çekmeceyi açıp arama kutusuna odaklan
  searchFocusButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer();
      window.setTimeout(function () {
        var input = drawer.querySelector('.drawer-search input[type="search"]');
        if (input) input.focus();
      }, 320);
    });
  });

  // Esc tuşuyla kapatma
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
});
